import { trigger, state, style, transition, animate } from '@angular/animations';

export const SignUpFormSlideAnimation = trigger('slideInOut', [
  state('true', style({ height: '*', opacity: 1 })),
  state('false', style({ height: '0px', opacity: 0 })),
  transition('false <=> true', animate('300ms ease-in-out')),
]);
